import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledPage = styled.div`
  border-radius: 8px;
  min-height: 100%;
  margin: 0 auto;

  .custom-table {
    tr,
    td {
      max-width: 200px;
    }

    .ant-form-item {
      margin-bottom: 0;
    }
  }

  .order-status-field {
    min-width: 305px;
  }

  .flex-end {
    display: flex;
    flex-grow: 1;
    justify-content: end;
  }

  .actions .text {
    color: ${({ theme }) => theme.colorButtonText};
  }

  .actions {
    width: 115px;
    height: 26px;
    border: 1px solid ${({ theme }) => theme.colorText};
    border-radius: 3px;
  }

  .actions .anticon-down {
    color: ${({ theme }) => theme.black};
  }

  .status-actions {
    width: 115px;
    border: solid 1px ${({ theme }) => theme.colorPrimary};
    border-radius: 3px;
  }

  .status-actions li {
    border-bottom: 1px solid ${({ theme }) => theme.colorStatusChangeLine};
  }

  .status-actions li:last-child {
    border-bottom: none;
  }

  .status-actions .ant-dropdown-menu {
    padding: 0px;
  }

  .ant-dropdown-menu-title-content {
    text-wrap: wrap;
    text-align: left;
  }

  .sort-arrows {
    display: inline-flex;
    flex-direction: column;
    position: relative;
    top: -5px;
  }

  .sort-arrow-active {
    color: ${({ theme }) => theme.sortArrowActive};
  }

  .sort-arrow-inactive {
    color: ${({ theme }) => theme.sortArrowInActive};
  }

  .sort-arrow {
    font-size: 9px;
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .ant-tabs-tab {
      padding: 16px 0px;
    }
  }
`;
